import { useContext, useMemo, useCallback } from 'react';
import moment from 'moment';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const useApprovedAtColumn = () => {
  const { t, dateFormat, timeFormat } = useContext(ConfigContext);

  const valueFormatter = useCallback(
    (params) => {
      if (!params.value) return '';
      return moment(params.value).format(`${dateFormat}, ${timeFormat}`);
    },
    [dateFormat, timeFormat]
  );

  // external rows are approved by the client, so fall back to clientApproved
  const valueGetter = useCallback(
    ({ data }) =>
      data?.adminApproved?.createdAt ??
      (data?.isExternal && data?.clientApproved ? data.clientApproved.createdAt : null),
    []
  );

  return useMemo(
    () => ({
      field: 'adminApproved.createdAt',
      headerName: t('approvedAt'),
      initialHide: true,
      sortable: false,
      cellClass: 'justify-start',
      width: 130,
      valueGetter,
      valueFormatter
    }),
    [t, valueGetter, valueFormatter]
  );
};

export default useApprovedAtColumn;
